'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _SearchBox = require('../components/SearchBox');

var _SearchBox2 = _interopRequireDefault(_SearchBox);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var itemsPropType = _propTypes2.default.arrayOf(_propTypes2.default.shape({
  value: _propTypes2.default.any,
  label: _propTypes2.default.node.isRequired,
  items: function items() {
    return itemsPropType.apply(undefined, arguments);
  }
}));

var List = function (_Component) {
  _inherits(List, _Component);

  function List() {
    _classCallCheck(this, List);

    var _this = _possibleConstructorReturn(this, (List.__proto__ || Object.getPrototypeOf(List)).call(this));

    _this.onShowMoreClick = function () {
      _this.setState(function (state) {
        return {
          extended: !state.extended
        };
      });
    };

    _this.getLimit = function () {
      var _this$props = _this.props,
          limit = _this$props.limit,
          showMoreLimit = _this$props.showMoreLimit;
      var extended = _this.state.extended;

      return extended ? showMoreLimit : limit;
    };

    _this.resetQuery = function () {
      _this.setState({ query: '' });
    };

    _this.renderItem = function (item, resetQuery) {
      var items = item.items && _react2.default.createElement(
        'ul',
        { className: _this.props.cx('list', 'list--child') },
        item.items.slice(0, _this.getLimit()).map(function (child) {
          return _this.renderItem(child, item);
        })
      );

      return _react2.default.createElement(
        'li',
        {
          key: item.key || item.label,
          className: _this.props.cx('item', item.isRefined && 'item--selected', item.noRefinement && 'item--noRefinement', items && 'item--parent')
        },
        _this.props.renderItem(item, resetQuery),
        items
      );
    };

    _this.state = {
      extended: false,
      query: ''
    };
    return _this;
  }

  _createClass(List, [{
    key: 'renderShowMore',
    value: function renderShowMore() {
      var _props = this.props,
          showMore = _props.showMore,
          translate = _props.translate,
          cx = _props.cx;
      var extended = this.state.extended;

      var disabled = this.props.limit >= this.props.items.length;
      if (!showMore) {
        return null;
      }

      return _react2.default.createElement(
        'button',
        {
          disabled: disabled,
          className: cx('showMore', disabled && 'showMore--disabled'),
          onClick: this.onShowMoreClick
        },
        translate('showMore', extended)
      );
    }
  }, {
    key: 'renderSearchBox',
    value: function renderSearchBox() {
      var _this2 = this;

      var _props2 = this.props,
          cx = _props2.cx,
          searchForItems = _props2.searchForItems,
          isFromSearch = _props2.isFromSearch,
          translate = _props2.translate,
          items = _props2.items,
          selectItem = _props2.selectItem;


      var noResults = items.length === 0 && this.state.query !== '' ? _react2.default.createElement(
        'div',
        { className: cx('noResults') },
        translate('noResults')
      ) : null;
      return _react2.default.createElement(
        'div',
        { className: cx('searchBox') },
        _react2.default.createElement(_SearchBox2.default, {
          currentRefinement: this.state.query,
          refine: function refine(value) {
            _this2.setState({ query: value });
            searchForItems(value);
          },
          focusShortcuts: [],
          translate: translate,
          onSubmit: function onSubmit(e) {
            e.preventDefault();
            e.stopPropagation();
            if (isFromSearch) {
              selectItem(items[0], _this2.resetQuery);
            }
          }
        }),
        noResults
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var _props3 = this.props,
          cx = _props3.cx,
          items = _props3.items,
          className = _props3.className,
          searchable = _props3.searchable,
          canRefine = _props3.canRefine;

      var searchBox = searchable ? this.renderSearchBox() : null;
      var rootClassName = (0, _classnames2.default)(cx('', !canRefine && '-noRefinement'), className);

      if (items.length === 0) {
        return _react2.default.createElement(
          'div',
          { className: rootClassName },
          searchBox
        );
      }

      // Always limit the number of items we show on screen, since the actual
      // number of retrieved items might vary with the `maxValuesPerFacet` config
      // option.
      return _react2.default.createElement(
        'div',
        { className: rootClassName },
        searchBox,
        _react2.default.createElement(
          'ul',
          { className: cx('list', !canRefine && 'list--noRefinement') },
          items.slice(0, this.getLimit()).map(function (item) {
            return _this3.renderItem(item, _this3.resetQuery);
          })
        ),
        this.renderShowMore()
      );
    }
  }]);

  return List;
}(_react.Component);

List.propTypes = {
  cx: _propTypes2.default.func.isRequired,
  // Only required with showMore.
  translate: _propTypes2.default.func,
  items: itemsPropType,
  renderItem: _propTypes2.default.func.isRequired,
  selectItem: _propTypes2.default.func,
  className: _propTypes2.default.string,
  showMore: _propTypes2.default.bool,
  limit: _propTypes2.default.number,
  showMoreLimit: _propTypes2.default.number,
  show: _propTypes2.default.func,
  searchForItems: _propTypes2.default.func,
  searchable: _propTypes2.default.bool,
  isFromSearch: _propTypes2.default.bool,
  canRefine: _propTypes2.default.bool
};
List.defaultProps = {
  className: '',
  isFromSearch: false
};
exports.default = List;


//////////////////
// WEBPACK FOOTER
// ./~/react-instantsearch/src/components/List.js
// module id = 189
// module chunks = 142807904292071